<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>邮件</li>
                <li><a href="#">已发邮件</a></li>
            </ul>
        </div>
    
        <div class="formbody">
            <ul class="seachform mt20">
    
                <li><label>收件人</label>
                    <div class="cityleft">
                        <input name="" v-model="email" type="text" class="scinput" />
                    </div>
                    
                </li>
                <li><label>邮件标题</label>
                    <div class="cityleft">
                        <input name="" v-model="title" type="text" class="scinput" />
                    </div>
                    
                </li>
    
                <li><label>&nbsp;</label><input name="" type="button" @click="pageChange(1)" class="scbtn" value="查询"/></li>
    
            </ul>

            <table class="tablelist">
                <thead>
                    <tr>
                        <th><input name="" type="checkbox" value=""/> </th>
                        <th>邮箱</th>
                        <th>标题</th>
                        <th>提交时间</th>
                        <th>状态</th>
                        <th>打开时间</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in emaillogList" :class="{odd:index%2!=0}">
                        <td style="width:3%"><input name="" type="checkbox" value="" /></td>
                        <td style="width:12%">{{item.email}}</td>
                        <td style="width:30%">{{item.title}}</td>
                        <td style="width:15%">{{item.createtime}}</td>
                        <td style="width:10%"><ol v-if="item.status==1">已发</ol><ol v-else-if="item.status==2">已查看</ol><ol v-else-if="item.status==-2">余额不足</ol></td>
                        <td style="width:15%">{{item.opentime}}</td>
                        <td style="width:10%"><a href="#" @click="delEmailLog(item.id)">删除</a> <a href="#" @click="showdetail(item.id)">详情</a></td>
                    </tr>
            </tbody>
        </table>
    
   
        <div class="pagin">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[50]"
                :page-size="50"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </div>
    
        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>
   
        <div class="jian">&nbsp;</div>
        </div> 
    
    
        <div class="tip">
    	    <div class="tiptop"><span>提示信息</span><a></a></div>
        
            <div class="tipinfo">
                <span><img src="images/ticon.png" /></span>
                <div class="tipright">
                    <p>是否确认对信息的修改 ？</p>
                    <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
                </div>
            </div>
            <div class="tipbtn">
                <input name="" type="button"  class="sure" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" value="取消" />
            </div>
        </div>
    
    
    </div>
    
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            email:'',
            title:'',
            emaillogList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            var that = this
            let data = {'pageIndex':pageIndex,'pageSize':50, 'email':this.email,'title':this.title}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/email/getemaillog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.emaillogList = res.data.emaillogList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        showdetail(id){
            location.href = "/emaillogdetail?id=" + id;
        },
        delEmailLog(id){
            var that = this
            let data = {'ids':id}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/email/delemaillog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$alert("删除成功！");
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/email/emaillog.vue